import * as z from "zod";

export const personalInfoSchema = z.object({
  full_name: z.string().min(2, "Name must be at least 2 characters"),
  headline: z.string().min(2, "Headline must be at least 2 characters"),
  bio: z.string().optional(),
  category_id: z.string().min(1, "Category is required"),
});